import script from "./VStepper.vue?vue&type=script&lang=ts&setup=true"
export * from "./VStepper.vue?vue&type=script&lang=ts&setup=true"

import "./VStepper.vue?vue&type=style&index=0&id=3f7d5745&lang=sass"

const __exports__ = script;

export default __exports__